import tinycolor from 'tinycolor2'

// Picks black or white text for legibility against a given background.
//
// Uses TinyColor's perceived-brightness test (the YIQ formula, flipping at
// a brightness of 128) rather than `mostReadable`. `mostReadable` maximizes
// the WCAG contrast ratio, which is computed from relative luminance and so
// weights green ~10x more than blue — on a saturated mid-tone blue like
// #038fb3 it scores black (5.58:1) above white (3.76:1) even though the
// envelope reads as a dark color and designers expect white addressing.
// YIQ brightness tracks that expectation. The two only ever disagree in
// this direction: nothing that gets white text today would flip to black.
//
// Shared between the recipient flow (`StaticAnimatedPage`) and the
// admin preview (`Preview`) so both pick the SAME --env-text-color for
// a given envelope color. Drift between the two would mean the admin
// preview doesn't accurately predict what the recipient will see.
export function contrastTextColor (bg: string): string {
  const color = tinycolor(bg)
  if (!color.isValid()) return '#fff'
  return color.isLight() ? '#000000' : '#ffffff'
}
